module.exports = __webpack_public_path__ + "img/logo-black-ink-vision.25b52ca0.svg";